
// src/components/BookShelf.js
import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import useEmblaCarousel from 'embla-carousel-react';
import {
  PrevButton,
  NextButton,
  usePrevNextButtons
} from '@/components/BookShelf/ArrowButtons'
import { useBookContext } from '../contexts/BookContext';
import { BookSkeleton } from '@/components/BookSkeleton';
import './BookShelf.css'

const BookShelf = ({ title, books, marginLeft }) => {
  const OPTIONS = {
    loop: true,
    // dragFree: true
    // align: 'center' ,
    startIndex: 3
  }

  const { dispatch } = useBookContext();
  const [emblaRef, emblaApi] = useEmblaCarousel(OPTIONS);
  const navigate = useNavigate();

  // title, books

  const bookList = books || []

  const {
    prevBtnDisabled,
    nextBtnDisabled,
    onPrevButtonClick,
    onNextButtonClick
  } = usePrevNextButtons(emblaApi);

  const handleBookClick = (book) => {
    dispatch({ type: 'SET_SELECTED_BOOK', payload: book });
    navigate(`/book/${book.bookID}`, { state: { title: book.title, author: book.author, bookCover:book.image } });
  };


  return (
    <div>
      <div className="book-shelf__header flex items-end justify-between mx-auto">
        <h1 className=" libre-baskerville-regular" style={{ fontSize: '17px' }}>{title}</h1>
        <div className="embla__controls">
          <div className="embla__buttons">
            <PrevButton onClick={onPrevButtonClick} disabled={prevBtnDisabled} />
            <NextButton onClick={onNextButtonClick} disabled={nextBtnDisabled} />
          </div>
        </div>

        {/* <br /> */}
      </div>
      {/* <br /> */}
      <section className="embla">
        <div className="embla__viewport" ref={emblaRef} >
          {/* 1st -10,  */}
          <div className="embla__container" style={{ '--shelf-offset': marginLeft } as React.CSSProperties}>

            {books === "loading" ?

              Array.from({ length: 10 }, (_, index) => (
                <div className="embla__slide" key={index} >
                  <div style={{ width: '452px', height: '344px' }}>
                    <BookSkeleton />
                  </div>



                  {/* <div className="w-5/6 h-6 mt-5 bg-gray-200 rounded "></div> */}
                  {/* <span className="author">{book.author}</span> */}
                </div>
              ))
              :
              bookList && bookList?.map((book, index) => (
                <div className="embla__slide" key={index} onClick={() => handleBookClick(book)}>
                  <img
                    className={`bookCover`}
                    src={book.image}
                    alt={book.title}
                  />
                  <p className="title">{book.title}</p>
                  <span className="author">{book.author}</span>
                </div>
              ))
            }

            { }
          </div>
        </div>
      </section>
    </div>
  );
};

export default BookShelf;

